import { Form } from 'antd';
import { Fragment } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import ViewEditModalHeader from 'components/modal/ViewEditModalHeader';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';

const ComptrollerModalContainer = ({
	form,
	icon,
	type,
	title,
	viewType,
	children,
	modalData,
	showModal,
	handleClose,
	confirmModal,
	handleUpdate,
	handleSubmit,
	setScreenSize,
	formSubmitData,
	onFieldsChange,
	setConfirmModal,
	screenSize = 'lg',
	handleDeactivate,
}) => {
	return (
		<Fragment>
			<Dialog
				keepMounted
				fullWidth={true}
				open={showModal}
				maxWidth={screenSize}
				aria-labelledby="draggable-dialog-title"
				fullScreen={screenSize === 'full' ? true : false}
				sx={{
					// old: '.MuiPaper-root': { borderRadius: '4px' }
					'.MuiPaper-root': {
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
						overflow: 'hidden',
					},
				}}
			>
				<ViewEditModalHeader
					type={type}
					icon={icon}
					viewType={viewType}
					headerTitle={title}
					screenSize={screenSize}
					handleClose={handleClose}
					setScreenSize={setScreenSize}
				/>

				<DialogContent
					sx={{
						// old: pb: '0', pt: '8px'
						pb: 0,
						pt: 1.5,
						px: 2,
						backgroundColor: '#FFFFFF',

						'& .ant-form-item-label': {
							paddingBottom: '12px',
						},
					}}
				>
					<Form
						form={form}
						layout="vertical"
						autoComplete="off"
						requiredMark={false}
						onFinish={handleSubmit}
						onFieldsChange={onFieldsChange}
					>
						{children}
					</Form>
				</DialogContent>
			</Dialog>

			{confirmModal && (
				<ComptrollerConfirmModal
					modalData={modalData}
					showModal={confirmModal}
					setShowModal={setConfirmModal}
					handleSubmit={() => (type === 'Edit' ? handleUpdate(formSubmitData) : handleDeactivate())}
				/>
			)}
		</Fragment>
	);
};
export default ComptrollerModalContainer;
